(function mobileAiRedirection() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'mobile-ai-redirection';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  $(() => {
    document.addEventListener('DOMContentLoaded', () => {
      localStorage.removeItem('chat_messages');
    });
  });
})();

